// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"KM-z","categoryName":"LM-z","categoryNameSearchHeader":"MM-z","categoryContent":"NM-z","bottomAligned":"OM-z","image":"PM-z","imageNoBackground":"QM-z"};